module.exports = __webpack_public_path__ + "static/media/tableDelete.35b4bbf3.svg";